export const scrollToPostId = (postId) => {
  const postToScroll = document.getElementById(`post-resp-${postId}`);
  if (postToScroll) {
    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: postToScroll.offsetTop - 60,
      });
    }, 500);
  }
};

export const scrollToResponses = () => {
  const responsesEl = document.getElementById('post-responses');
  if (responsesEl) {
    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: responsesEl.offsetTop - 70,
    });
    }, 50);
  }
};
